import '../PushProducts.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SOURCE } from '@/common/constants';
import useProductsLastViewed from '@/common/hooks/products/useProductsLastViewed';
import Loader from '@/ebat/components/blocks/Common/Loader/Loader';
import ProductSlider from '@/ebat/components/blocks/ProductSlider/ProductSlider';
import { TAG_MANAGER } from '@/ebat/constants';

import {
  PushLastViewDefaultProps,
  PushLastViewPropTypes,
} from './PushLastView.proptypes';

const PushLastView = ({ className, limit, refetchCart }) => {
  const { t } = useTranslation();

  /**
   * Get products last view
   */
  const { data: products, isSuccess, isLoading } = useProductsLastViewed({
    limit,
  });

  const productSet = useMemo(
    () =>
      products?.data?.map((item) => ({
        ...item,
        price_and_stock: {
          ...item.price_and_stock,
          has_price: false,
          has_stock: false,
        },
        source: SOURCE.LAST_SEEN,
      })),
    [products],
  );

  const isDisabled = useMemo(() => {
    const loading = isLoading;

    return {
      disabled: loading,
      loading,
      notDisplayable:
        !isLoading &&
        (products === undefined || products?.data?.length === 0 || !products),
    };
  }, [isLoading, products]);

  /**
   * Don't display the component
   */
  if (isDisabled.notDisplayable) {
    return null;
  }

  if (!products) {
    return null;
  }

  return (
    <div
      className={cn('push-products', 'push-products--last-view', className)}
      data-qa-id="push-last-view"
    >
      <div className="wrapper">
        <div className="push-products__title">
          <h2 className="h2">
            {t('ebat:entities:common.push_products.last_view')}
          </h2>
        </div>
        {isSuccess && (
          <ProductSlider
            addToCartOptions={{
              dataLayer: {
                origin: TAG_MANAGER.ORIGINS.LAST_VIEWED,
              },
            }}
            className="push-products__slider"
            products={productSet}
            refetchCart={refetchCart}
          />
        )}
        {isLoading && <Loader type="full" className="push-products__loader" />}
      </div>
    </div>
  );
};

PushLastView.defaultProps = {
  ...PushLastViewDefaultProps,
};

PushLastView.propTypes = {
  ...PushLastViewPropTypes,
};

export default PushLastView;
